"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("reshow-runtime/helpers/objectSpread2"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("reshow-runtime/helpers/objectWithoutPropertiesLoose"));
var _classLib = require("class-lib");
var _callFunc = _interopRequireDefault(require("call-func"));
var _SemanticUI = _interopRequireDefault(require("../molecules/SemanticUI.js"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "children"];
var Unsafe = function Unsafe(_ref) {
  var className = _ref.className,
    children = _ref.children,
    restProps = (0, _objectWithoutPropertiesLoose2["default"])(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SemanticUI["default"], (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, restProps), {}, {
    className: (0, _classLib.mixClass)("us-html", className),
    dangerouslySetInnerHTML: {
      __html: (0, _callFunc["default"])(children)
    }
  }));
};
var _default = exports["default"] = Unsafe;
module.exports = exports.default;